import React from "react";
import TabcordionMediaCard from "components/page/campaign/tabcordion/TabcordionMediaCard";
import TabcordionLinks from "components/page/campaign/tabcordion/TabcordionLinks";
import { sanitizeHtml } from "utils/sanitizeHtml";
const TabCordionContentTwoColumn = ({ componentTitle, tab }) => {
	return (
		<div className="tabcordion--two-column">
			{tab.goalDescription && (
				<div
					className="tabcordion--two-column-description t-body-md"
					dangerouslySetInnerHTML={{ __html: sanitizeHtml(tab.goalDescription) }}
				></div>
			)}
			<TabcordionMediaCard tab={tab} />
			<TabcordionLinks componentTitle={componentTitle} tab={tab} />
		</div>
	);
};

export default TabCordionContentTwoColumn;
